module.exports = __webpack_public_path__ + "img/on-the-road.c9804e37.jpg";